export const saveFile = (data: string | Blob, fileName: string) => {
  let currentLink = '';
  if (data instanceof Blob) {
    currentLink = URL.createObjectURL(data);
  } else {
    currentLink = data;
  }
  const a = document.createElement('a');
  a.download = fileName;
  a.href = currentLink;
  a.click();
  a.remove();
};
